import React, { useEffect, useState } from "react";
import Container from "../../Container/Container";
import "./Preview.scss";
import Buttons from "../../components/Button/Button";
import ShareIcon from "@mui/icons-material/Share";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { getProductTable } from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import parse from "html-react-parser";
import Langtrans from "../../components/Langtrans/Langtrans";
import CircularProgress from "@mui/material/CircularProgress";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Snackbar from "../../components/Snackbar/Snackbar";
import Modals from "../../components/Modal/Modal";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import { campaignData } from "../../store/action";
import { updateProductTable } from "../../graphql/mutations";
import Logo from "../../assets/LAETUS.png";
import moment from "moment";
const Donepreview = () => {
  const { t } = useTranslation();
  const [previewData, setPreviewData] = useState(null);
  const [openmodal, setopenmodal] = useState(true);
  const [copied, setCopied] = useState(false);
  const [data, setData] = useState(window?.location?.href);
  const [msg, setmsg] = useState("");
  const [errMsg, seterrMsg] = useState("");
  const [databtn, setdatabtn] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const campaign = useSelector((state) => state.campaign.campaign);

  const stop = async () => {
    setdatabtn(true);
    try {
      API.patch("laetusapi", "/api/v1/updateproduct", {
        body: {
          show_on_shop: previewData.isStop ? true : false,
          id: previewData.weflowProductId,
        },
      })
        .then(async (res) => {
          const data = await API.graphql(
            graphqlOperation(updateProductTable, {
              input: {
                isStop: !previewData.isStop ? true : false,
                id: previewData.id,
              },
            })
          );
          setmsg(
            !previewData.isStop ? t("stop-campaign") : t("resume-campaign")
          );
          setdatabtn(false);
          setPreviewData(data.data.updateProductTable);
          setTimeout(() => {
            setmsg("");
          }, 1500);
        })
        .catch(() => {
          setdatabtn(false);
        });
    } catch (error) {
      seterrMsg(error.message);
      setdatabtn(false);
    }
  };

  const remainDate = (createdAt, days) => {
    const currentDate = moment(createdAt, "YYYY-MM-DD");
    const futureDate = moment(currentDate._d).add(days, "days");
    const endDate = moment(futureDate._d).format("YYYY-MM-DD");
    const todaysdate = moment();
    return moment(endDate).diff(todaysdate, "days");
  };

  const fetchPreview = async () => {
    if (!id) {
      return;
    }
    try {
      const { data } = await API.graphql(
        graphqlOperation(getProductTable, { id: id })
      );
      setPreviewData(data?.getProductTable);
    } catch (er) {
      return er;
    }
  };

  const AddtoCart = (data) => {
    const exist = campaign?.find((item) => item.id === data?.id);
    if (exist) {
      history.push("/order");
      dispatch(
        campaignData({
          campaign: campaign.map((x) =>
            x.id === data?.id ? { ...exist, quantity: exist.quantity + 1 } : x
          ),
        })
      );
    } else {
      history.push("/order");
      dispatch(
        campaignData({
          campaign: [...campaign, { ...data, quantity: 1 }],
        })
      );
    }
  };

  useEffect(() => {
    fetchPreview();
  }, []);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    }
  }, []);

  if (!previewData) {
    return (
      <div className="loading">
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <Container>
        {/* <Langtrans login trans /> */}
        <div className="preview-header">
          <div
            className="preview-logo cp"
            onClick={() => history.push("/home")}
          >
            <img src={Logo} alt="logo" height={130} />
          </div>
          <div>
            {remainDate(previewData.createdAt, previewData.days) !== 0 && (
              <>
                {!previewData.isStop ? (
                  <Buttons
                    text={`< ${t("stop_campaign")}`}
                    className="campaign-btn btn red-clr"
                    onClick={() => stop()}
                    loader={databtn}
                  />
                ) : (
                  <Buttons
                    text={`< ${t("resume_campaign")}`}
                    className="campaign-btn btn green-clr"
                    onClick={() => stop()}
                    loader={databtn}
                  />
                )}
              </>
            )}
            <Buttons
              text={`< ${t("share_campaign")}`}
              className="campaign-btn btn"
              onClick={() => setopenmodal(true)}
            />
          </div>
        </div>
      </Container>
      <div className="preview-mid">
        <div>
          <h2>{t("share_campaign")} </h2>
        </div>
        <div className="link">
          <ShareIcon className="icons" />
          <input
            type="text"
            value={previewData.weflowProductURL}
            disabled={true}
            className="clipBoard"
          />
          <CopyToClipboard
            text={previewData.weflowProductURL}
            onCopy={() => setCopied(true)}
          >
            <Buttons text={`< ${t("copy_link")}`} className="copy-btn btn" />
          </CopyToClipboard>
        </div>

        <div className="icon-link">
          <FacebookShareButton
            url={previewData.weflowProductURL}
            quote={`Je viens de lancer ma campagne ${previewData.shirtName} sur LAETUS ! Précommandez dès maintenant : ${previewData.weflowProductURL} `}
          >
            <FacebookIcon className="icons" />
          </FacebookShareButton>
          <TwitterShareButton
            title={`Je viens de lancer ma campagne ${previewData.shirtName} sur @laetus_store ! Précommandez dès maintenant :${previewData.weflowProductURL} `}
            url=" "
          >
            <TwitterIcon className="icons" />
          </TwitterShareButton>
        </div>
      </div>
      <Container>
        <div className="campaign">
          <div>
            <div className="shirt">
              <img
                src={previewData.designShirt}
                alt="shirt"
                width={500}
                height={500}
              />
            </div>
          </div>
          <div className="description-preview">
            <p className="days">
              {previewData.days} {t("days_left")}
            </p>
            <h3>{previewData.shirtName}</h3>
            <p className="price">{previewData.sellingPrice} €</p>
            <p className="prototype">{previewData.brief}</p>
          </div>
          <div className="card-main">
            <div className="card">
              <div className="card-content">
                <div>
                  <Buttons
                    text={`> ${t("buy")}`}
                    onClick={() => AddtoCart(previewData)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="berief-desc">
					<h2>{t("additional_inform")}</h2>
					<div>
						{previewData.detail && parse(JSON.parse(previewData.detail))}
					</div>
				</div> */}
        {copied && <Snackbar message="Copied!" />}
        {msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
        <Modals
          condition="donePreview"
          setopenmodal={setopenmodal}
          openmodal={openmodal}
          weflowProductURL={previewData.weflowProductURL}
        />
      </Container>
    </>
  );
};
export default Donepreview;
